import Alert from "@/components/Alert";
import { Outlet } from "react-router";
import * as jose from "jose";
import { useMemo } from "react";

export const SURVEY_DELIVERY_ID_KEY = "livly-token/claims/SurveyDeliveryId";

export interface SurveyExternalToken {
  [SURVEY_DELIVERY_ID_KEY]: string;
}

export interface SurveyExternalContext {
  token: string;
  surveyDeliveryId: number;
}

function SurveyExternalContextProvider() {
  const context = useMemo(() => getSurveyExternalContext(), []);

  if (!context) {
    return (
      <div className="p-4">
        <Alert message="We cannot process your request." />
      </div>
    );
  }

  return <Outlet context={context} />;
}

export default SurveyExternalContextProvider;

function getSurveyExternalContext(): SurveyExternalContext | null {
  try {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("ltoken") as string;

    if (!token) {
      return null;
    }

    const decoded = jose.decodeJwt(token) as SurveyExternalToken;
    const surveyDeliveryId = Number(decoded[SURVEY_DELIVERY_ID_KEY]);

    if (!Number.isFinite(surveyDeliveryId) || surveyDeliveryId <= 0) {
      return null;
    }

    return { token, surveyDeliveryId };
  } catch {
    return null;
  }
}
